<template>
  <div class="zipcode-confirm">
    <div class="zipcode-confirm-shadow" @click="closePopup"></div>
    <div class="zipcode-confirm-main">
      <p class="main-title">{{ letter.zipCodeSwitchZipCode }}</p>
      <div class="main-content">
        <p class="main-content-title">
          {{ letter.areaLimitPreSwitchRegionCurrency }}
        </p>
        <div class="main-box">
          <div class="box-area">
            <p>{{ letter.areaLimitRegion }}</p>
            <p class="text">{{ curLocationName }}</p>
          </div>
          <div class="box-area">
            <p>{{ letter.areaLimitCurrency }}</p>
            <p class="text">{{ defaultCurrency }}</p>
          </div>
        </div>
        <div class="main-form">
          <div class="main-form-box">
            <div class="main-form-box-item">
              <p>{{ letter.zipCodeState }}</p>
              <DataList
                class="main-select main-input"
                v-bind:value.sync="nextStateName"
                :options="usStateOptions"
                @select="selectState"
              ></DataList>
            </div>
            <div class="main-form-box-item">
              <p>zipcode</p>
              <DataList
                class="main-select main-input"
                v-bind:value.sync="nextZipCode"
                :options="zipCodeOptions"
                @change="zipcodeChange"
                type="number"
              ></DataList>
            </div>
          </div>
          <p v-if="!zipCodeValidor" class="main-tips">
            {{ letter.areaLimitEnterInvalid }}
          </p>
          <p class="main-tax-tips">
            {{ `${letter.zipCodeRate}:${curTaxRate}%` }}
          </p>
        </div>
        <p>{{ letter.areaLimitTaxRateTips }}</p>
        <!-- 还没有多语言，暂时写死英语，后续可替换为已有的对应多语言 -->
        <p
          @click="jumpAreaLimitPolicy"
          v-html="
            letter.areaLimitInfoCollect.replace(
              '\${policy}',
              `<span class='area-switch-popup-link'>[Privacy Policy]</span>`
            )
          "
        ></p>
        <div class="main-btn-wrap">
          <a class="cancel btn" href="javascript:;" @click="closePopup">
            {{ letter.cancel }}
          </a>
          <a
            v-if="mode === 'order'"
            class="confirm btn"
            href="javascript:;"
            @click="confirmPay"
          >
            {{ letter.areaLimitContinuePay }}
          </a>
          <a v-else class="confirm btn" href="javascript:;" @click="confirm">
            {{ letter.areaLimitConfirmSwitch }}
          </a>
        </div>
      </div>
      <a href="javascript:;" class="main-close" @click="closePopup"></a>
    </div>
  </div>
</template>

<script>
import areaLimit from '@mixins/areaLimit';
import zipcode from '@mixins/officialTopup/zipcode';
import { mapState } from 'vuex';
import { clickButton, locationType } from '@plugins/biPoint/_configWebstoreV3';
export default {
  name: 'ZipCodeConfirmPopup',
  mixins: [areaLimit, zipcode],
  props: {
    mode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nextZipCode: '',
      isEditZipCode: false
    };
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      letter: state => state.letter,
      zipCode: state => state.zipCode,
      ipLocation: state => state.ipLocation,
      defaultCurrency: state => state.defaultCurrency,
      curLocation: state => state.curLocation
    }),
    zipCodeOptions() {
      return this.currentZipCodeList.filter(item =>
        item.value.includes(this.nextZipCode)
      );
    },
    usStateOptions() {
      const US_STATES = this.getUsStateOptions();
      return US_STATES.filter(item => {
        return item.label
          .toUpperCase()
          .includes(this.nextStateName.toUpperCase());
      });
    }
  },
  methods: {
    closePopup() {
      clickButton({
        btnName: 'close_regions',
        locationKey: locationType.areaLimitConfirm
      });
      this.$emit('handleZipCodeConfirmPopup', false);
    },
    async confirmPay() {
      await this.zipCodeValidorFunc();
      if (this.zipCodeValidor) {
        clickButton({
          btnName: 'continue_to_pay',
          locationKey: locationType.areaLimitConfirm
        });
        window.webstorev3DataLayer.push({
          eventName: 'bind_zipcode',
          eventType: this.isEditZipCode ? 'input' : 'ip',
          eventValue: this.nextZipCode
        });
        this.$emit('confirmZipCodeAndPostOrder', {
          game_id: this.gameId,
          location_code: this.curLocation,
          default_currency: this.defaultCurrency,
          zip_code: this.nextZipCode,
          force: 1
        });
      }
    },
    async confirm() {
      await this.zipCodeValidorFunc();
      if (this.zipCodeValidor) {
        if (this.nextZipCode === this.zipCode) {
          this.closePopup();
          return;
        }
        this.$emit('confirmSwitchArea', {
          game_id: this.gameId,
          location_code: this.curLocation,
          default_currency: this.defaultCurrency,
          zip_code: this.nextZipCode,
          force: 1
        });
      }
    },
    getLocationCurrencyList(locationCode, isInit = false) {
      this.$store
        .dispatch(GET_LOCATION_CURRENCY_LIST, { location_code: locationCode })
        .then(res => {
          this.locationCurrencyList = res.data;
          if (!isInit) {
            this.nextCurrency = this.locationCurrencyList?.[0];
          }
        });
    },
    // 选择美国州
    selectState(curState) {
      this.nextZipCode = '';
      this.nextStateName = curState.label;
      this.nextStateCode = curState.value;
      this.getZipCodeList(curState.value);
    },
    async zipcodeChange() {
      await this.zipCodeValidorFunc();
    }
  },
  mounted() {
    this.nextZipCode = this.zipCode || this.ipZipCode || '';
    this.zipCodeValidorFunc();
  },
  watch: {
    nextZipCode(val) {
      if (val && val !== this.ipZipCode) {
        this.isEditZipCode = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialTopup/officialTopup.scss';

.zipcode-confirm {
  z-index: 21;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }

  &-main {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 660px;
    transform: translate(-50%, -50%);
    background: $backgroundColor;
    border-radius: 10px;
  }
}

.main {
  &-close {
    position: absolute;
    right: 32px;
    top: 27px;
    background: url($commonImg + 'close.png') no-repeat;
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  &-title {
    font-size: 26px;
    text-align: center;
    line-height: 86px;
    height: 86px;
    @include g-popup-title();
    border-radius: 20px 20px 0 0;
    margin: 0;
  }

  &-content {
    font-size: 24px;
    text-align: start;
    padding: 42px 32px;
    line-height: 1.5;
    margin-bottom: 160px;
  }

  &-content-title {
    font-size: 28px;
    line-height: 36px;
  }

  &-box {
    width: 595px;
    display: flex;
    margin: 38px auto 14px;
    background-color: #f6f6f6;
    border-radius: 6px;
    border: solid 2px;
    border-color: #999999;

    .box-area {
      font-size: 22px;
      color: #333333;
      width: 50%;
      text-align: start;
      padding: 14px 22px;

      .text {
        font-size: 28px;
        color: $themeColor;
      }
    }

    .box-area + .box-area {
      border-left: 2px solid #999999;
    }
  }

  &-form {
    margin-bottom: 72px;
  }
  &-form-box {
    display: flex;
    &-item {
      width: 50%;
      box-sizing: border-box;
    }
    &-item + &-item {
      margin-left: 10px;
    }
  }
  &-select {
    margin: 10px auto;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    padding: 0 20px;
    height: 80px;
    background-color: #ffffff;
    border-radius: 6px;
    border: solid 2px #d2d2d2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 22px;
    cursor: pointer;

    ::v-deep .select {
      padding: 0 20px !important;
    }

    ::v-deep .select-icon {
      right: 0;
    }
  }

  &-tips {
    color: #d25f27;
    float: left;
  }

  &-tax-tips {
    float: right;
    width: 50%;
  }

  &-btn-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 65px;
    display: flex;
    justify-content: center;
    align-items: center;

    .btn {
      width: 244px;
      height: 80px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      font-size: 28px;
      color: #fff;
      border-radius: 10px;
      padding: 0 10px;
      cursor: pointer;
    }

    .confirm {
      background: $themeColor;
    }

    .cancel {
      background: #ffffff;
      border-radius: 9px;
      border: solid 2px #d2d2d2;
      color: #333333;
    }
  }
}
::v-deep .datalist-input {
  font-size: 22px;
}
.active {
  border-color: $themeColor !important;
}
</style>
